import React from 'react';

import './Comment.css';

const Comment = (props) => {
  // Helper to get field error (supports custom fieldName or defaults to props.label)
  const getError = () => {
    if (!props?.getFieldError) return null;

    // Use provided fieldName or try to derive from label
    const fieldName =
      props.fieldName ||
      (props.label ? props.label.toLowerCase().replace(/\s+/g, '') : null);

    return fieldName ? props.getFieldError(fieldName) : null;
  };

  // Helper to check if should show error
  const shouldShowError = () => {
    return props?.errMsg && getError();
  };

  return (
    <div className={shouldShowError() ? 'reasonMissed error' : 'reasonMissed'}>
      <label htmlFor={props.commentsId}>{props.label || 'Comments'}:</label>
      <textarea
        id={props.commentsId}
        name="comments"
        value={props.payload}
        className="reasonMissedText"
        cols="30"
        rows="3"
        onChange={(e) => props.onHandleChange(e)}
      />
      {shouldShowError() && <span className="error-text">{getError()}</span>}
    </div>
  );
};

Comment.propTypes = {};

export default Comment;
